export const ActionTypes = {
  SET_RETENTION_OUTPUTS: "RETENTION_OUTPUTS_SET_RETENTION_OUTPUTS",
  ADD_RETENTION_OUTPUT: "RETENTION_OUTPUTS_ADD_RETENTION_OUTPUT",
  SET_FILTERS: "RETENTION_OUTPUTS_SET_FILTERS",
  UPDATE_RETENTION_OUTPUT: "RETENTION_OUTPUTS_UPDATE_RETENTION_OUTPUT",
  REMOVE_RETENTION_OUTPUT: "RETENTION_OUTPUTS_REMOVE_RETENTION_OUTPUT",
  CLEAR_RETENTION_OUTPUTS: "RETENTION_OUTPUTS_CLEAR_RETENTION_OUTPUTS",
  RESTORE_INITIAL: "RETENTION_OUTPUTS_RESTORE_INITIAL",
};
